module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switcher-el-container"
  }, [(_vm.showCoinSwitcher) ? _c('div', {
    staticClass: "modal is-active is-clipped",
    on: {
      "click": function($event) {
        return _vm.closeCoinSwitcher()
      }
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-card",
    attrs: {
      "tabindex": "0",
      "id": _vm.idModal
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeCoinSwitcher()
      }
    }
  }, [_c('div', {
    staticClass: "modal-card-body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('coin-list', {
    on: {
      "selected": _vm.selectCoin
    }
  })], 1)]), _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.closeCoinSwitcher()
      }
    }
  })]) : _vm._e(), _c('span', {
    staticClass: "coin-switcher",
    class: {
      'hint--always': _vm.showHint && !_vm.compact,
      'hint--top': _vm.hintTop && !_vm.isMobile && !_vm.compact,
      'hint--right': !_vm.hintTop && !_vm.isMobile && !_vm.compact,
      'hint--bottom': _vm.isMobile && !_vm.compact,
      'compact hint--bottom-right': _vm.compact
    },
    attrs: {
      "id": _vm.id,
      "tabindex": "0",
      "aria-label": (_vm.isMobile || _vm.compact ? 'Choose' : 'Click to choose') + ' from 80+ different crypto coins & tokens!'
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.openCoinSwitcher()
      },
      "click": function($event) {
        return _vm.openCoinSwitcher()
      }
    }
  }, [(!_vm.compact) ? _c('div', {
    staticClass: "coin-symbol"
  }, [_c('div', [_vm._v(_vm._s(_vm.coin))]), _c('div', {
    staticClass: "coin-name-small"
  }, [_vm._v(_vm._s(_vm.coinName))])]) : _vm._e(), _c('img', {
    attrs: {
      "src": _vm.coinLogo
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-005e2d69","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_coin_switcher.vue
// module id = 351
// module chunks = 1